import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { StudentGradesByProgramType } from '../../../../../api/types/programs/external-exams/program-external-exam';

export const getProgramExternalExamDetailsOperation = async (
  branchId: number,
  programId: number,
  setData: (data: StudentGradesByProgramType | null) => void,
  setLoading: (isLoading: boolean) => void,
) => {
  try {
    setLoading(true);
    const res = await appApi.getProgramExternalExamDetails(branchId, programId);

    if (res.data.ok) {
      setData(res.data.body);
    } else {
      toast.error(
        'טעינת נתוני מבחנים חיצוניים נכשלה, נסה שוב בעוד מספר רגעים...',
      );
      setData(null);
    }
    setLoading(false);
  } catch (e) {
    toast.error(
      'טעינת נתוני מבחנים חיצוניים נכשלה, נסה שוב בעוד מספר רגעים...',
    );
    console.error(
      `getProgramExternalExamDetailsOperation failed for branchId: ${branchId}, programId: ${programId} with error: ${e}`,
    );
    setData(null);
    setLoading(false);
  }
};
